export default cookieName => {
  const foundCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${cookieName}=`));

  if (foundCookie) {
    return foundCookie.split('=')[1];
  }
  return null;
};
